<template>
    <carousel :per-page="1" :navigationEnabled="true" :navigationClickTargetSize="14"
              :loop="true" :autoplay="true" :autoplayTimeout="5000"
              navigationNextLabel="<i class='glyphicon glyphicon-chevron-right'></i>"
              navigationPrevLabel="<i class='glyphicon glyphicon-chevron-left'></i>">
        <slide v-for="slide in slides" :key="slide.head" class="text-center col-xs-12">
            <div class="vueslide">
                <div class="slider-icon hep-icon hep-stars5"></div>
                <p>{{ slide.head }}</p>
                <span v-html="strippedHtml(slide.text)"></span> <a :href="slide.link" target="_blank">{{ slide.link_text }}</a>
            </div>
        </slide>
    </carousel>
</template>

<script>
    export default {
        props: ['slides'],
        name: "aboutQuotes",
        methods: {
            strippedHtml: function (value) {
                return value.replace(/(<([^>]+)>)/gi, "");
            }
        }
    }
</script>